module.exports = __webpack_public_path__ + "static/media/timeline2.3c2789c9.png";